/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "../../styles/containers/CreateCheckup.scss";
import Form from "../../components/Form";
import { connect } from "react-redux";
import {
  createCheckup,
  getCheckupType,
  createcheckup,
} from "../../store/actions/checkupsActions";
import { createCheckupValidation } from "../../validation";
import { Formik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import { useHistory } from "react-router";
import moment from "moment";
const Button = { title: "Create", type: "submit" };

function CreateCheckup({
  createCheckup,
  error,
  message,
  checkupTypes,
  isPost,
  getCheckupType,
  success,
  createcheckup,
  parkID,
  checkupTypeError,
}) {
  const [loading, setLoading] = useState(false);
  const [typeOptions, setTypeOptions] = useState([
    { value: "", label: "Select type", id: "" },
  ]);
  let history = useHistory();

  const createCheckupForm = [
    {
      input: "text",
      type: "number",
      placeholder: "Operating hours",
      name: "opHours",
      id: "opHours",
    },
    {
      input: "dropdown",
      id: "date",
      type: "date",
      placeholder: "Select date",
      name: "date",
      // min: new Date().toISOString().split("T")[0],
    },
    {
      input: "dropdown",
      id: "type",
      placeholder: "Select type",
      options: typeOptions,
      name: "type",
    },
    {
      input: "text",
      type: "number",
      placeholder: "Length of TOP running cable",
      name: "lengthOfUpperCable",
      id: "lengthOfUpperCable",
    },

    {
      input: "text",
      type: "number",
      placeholder: "Length of BOTTOM running cable",
      name: "lengthOfLowerCable",
      id: "lengthOfLowerCable",
    },
  ];

  useEffect(() => {
    if (!checkupTypes?.length) getCheckupType();
  }, []);

  useEffect(() => {
    if (checkupTypeError)
      toast.error(`Error in getting checkup types ${checkupTypeError}`);
  }, [checkupTypeError]);

  useEffect(() => {
    if (isPost) setLoading(false);
    if (success && isPost) {
      toast.success(message);
      createcheckup();
      history.push("/last-checkups");
    }
  }, [isPost]);

  useEffect(() => {
    if (checkupTypes?.length) {
      let options = [{ value: "", label: "Select type", id: "" }];
      checkupTypes.map((type) =>
        options.push({ value: type.name, label: type.name, id: type.id })
      );

      setTypeOptions(options);
    }
  }, [checkupTypes]);

  const handleSubmit = ({
    opHours,
    lengthOfLowerCable,
    lengthOfUpperCable,
    date,
    type,
  }) => {
    const data = {
      op_hours: opHours,
      length_of_upper_cable: lengthOfUpperCable,
      length_of_lower_cable: lengthOfLowerCable,
      date: moment(date).format("YYYY-MM-DD"),
      type: type.value,
      type_id: type.id,
      created_by: localStorage.getItem("userName"),
      park_id: parseInt(parkID),
    };

    createCheckup(data);
    setLoading(true);
  };

  const values = {
    opHours: "",
    lengthOfUpperCable: "",
    lengthOfLowerCable: "",
    date: "",
    type: "",
  };

  return (
    <div className="CreateCheckup">
      <h1 className="main-heading">Create Checkup</h1>
      <Formik
        initialValues={values}
        validationSchema={createCheckupValidation}
        onSubmit={handleSubmit}
      >
        {({
          handleSubmit,
          handleChange,
          setFieldTouched,
          values,
          touched,
          errors,
          setFieldValue,
        }) => {
          const onInputChange = (name, e, type) => {
            if (type === "dropdown") setFieldValue(name, e, true);
            else if (name === "date") {
              setFieldValue(name, e, true);
            } else {
              e.persist();
              handleChange(e);
            }
            setFieldTouched(name, true, false);
          };
          return (
            <Form
              button={Button}
              fields={createCheckupForm}
              id="Create-Checkup"
              handleFormData={onInputChange}
              data={values}
              submitForm={handleSubmit}
              touched={touched}
              errors={errors}
              errorMessage={error}
              loading={loading}
            />
          );
        }}
      </Formik>
      <ToastContainer position={toast.POSITION.TOP_RIGHT} autoClose={2000} />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    success: state?.checkups?.createCheckup?.success,
    error: state?.checkups?.createCheckup?.error,
    checkupTypeError: state?.checkups?.checkupTypes?.error,
    message: state?.checkups?.createCheckup?.message,
    isPost: state?.checkups?.createCheckup?.isPost,
    checkupTypes: state?.checkups?.checkupTypes?.checkupTypes,
    parkID: state?.users?.getUser?.user?.park_id,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createCheckup: (data) => dispatch(createCheckup(data)),
    getCheckupType: () => dispatch(getCheckupType()),
    createcheckup: () => dispatch(createcheckup()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateCheckup);
